import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

export interface ConfirmRequest {
  title: string;
  description: React.ReactNode;
  confirmLabel: string;
  destructive?: boolean;
  onConfirm: () => void;
}

interface ConfirmDialogProps {
  /** The pending confirmation; null closes the dialog. */
  request: ConfirmRequest | null;
  onClose: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ request, onClose }) => (
  <AlertDialog open={request !== null} onOpenChange={(open) => !open && onClose()}>
    {/* Never wider than a phone screen; long unbroken text (emails) wraps instead. */}
    <AlertDialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-lg">
      <AlertDialogHeader>
        <AlertDialogTitle className="[overflow-wrap:anywhere]">{request?.title}</AlertDialogTitle>
        <AlertDialogDescription className="[overflow-wrap:anywhere]">
          {request?.description}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={() => request?.onConfirm()}
          className={cn(
            request?.destructive &&
              "bg-destructive text-destructive-foreground hover:bg-destructive/90"
          )}
        >
          {request?.confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDialog;
